import {APPS, SCOPES} from 'lib.common/dist/constantes';
import {SCRN_DASHBOARD} from 'src/constants/screens';
const backEnd = process.env.REACT_APP_BACK_END;
const log = process.env.REACT_APP_API_DSLOGIN;
const crm = process.env.REACT_APP_CRM;
export const baseName = process.env.REACT_APP_BASE_NAME || '/';
export const urls = {
   backEnd,
   graph: backEnd + '/graphql',
   verify: backEnd + '/verify'
};
export const urlsLog = {
   log,
   graph: log + '/graphql'
};
export const urlsCrm = {
   crm,
   graph: crm + '/graphql'
};

export const apiRestUrl = process.env.REACT_APP_API_REST;
export const dsCentralUrl = process.env.REACT_APP_API_AUTH;
export const appName = 'DS-Monitor';
export const appId = APPS.monitor;
export const callbackRoute = '/callback';
export const defaultRoute = process.env.REACT_APP_DEFAULT_ROUTE
   ? process.env.REACT_APP_DEFAULT_ROUTE
   : SCRN_DASHBOARD;

export const backEndDsKey = process.env.DSKEY_BACK_END;

export const appsUrlsApi =
   //   process.env.NODE_ENV !== 'production'
   //      ?
   {
      key: process.env.REACT_APP_URL_API_KEY,
      crm: process.env.REACT_APP_URL_API_CRM
   };
